import yup from "utilities/form/yup";

export interface IJobAccessVm {
    accessorId: number;
    accessorName: string;
    hasAccess: boolean;
    hasNotificationAccess: boolean;
    disableAccess: boolean;
    archived: boolean;
    jobStatusAccess: number[];
    autoAddJobsites: boolean;
    jobDefaultBillRate: number | null;
    jobDefaultCostRate: number | null;
    userDefaultBillRate: number | null;
    primaryContact?: string;
    businessPhone?: number;
    cellPhone?: number;
}

export class ViewingAccessRowEntity {
    constructor(data: IJobAccessVm) {
        this.accessorId = data.accessorId;
        this.accessorName = data.accessorName;
        this.businessPhone = data.businessPhone;
        this.cellPhone = data.cellPhone;
        this.hasAccess = data.hasAccess;
        this.hasNotificationAccess = data.hasNotificationAccess;
        this.disableAccess = data.disableAccess;
        this.primaryContact = data.primaryContact;
        this.archived = data.archived;
        this.jobStatusAccess = data.jobStatusAccess;
        this.autoAddJobsites = data.autoAddJobsites;
        this.jobDefaultBillRate = data.jobDefaultBillRate;
        this.jobDefaultCostRate = data.jobDefaultCostRate;
        this.userDefaultBillRate = data.userDefaultBillRate;
    }
    accessorId: number;
    accessorName: string;
    businessPhone?: number;
    cellPhone?: number;
    hasAccess: boolean;
    hasNotificationAccess: boolean;
    disableAccess: boolean;
    primaryContact?: string;
    archived: boolean;
    jobStatusAccess: number[];
    autoAddJobsites: boolean;
    jobDefaultBillRate: number | null;
    jobDefaultCostRate: number | null;
    userDefaultBillRate: number | null;
}

export class ViewingAccessRowFormValues {
    constructor(row: IJobAccessVm) {
        this.accessorId = row.accessorId;
        this.hasAccess = row.hasAccess;
        this.hasNotificationAccess = row.hasNotificationAccess;
        this.accessorName = row.accessorName;
        this.isSelected = false;
        this.disableAccess = row.disableAccess;
        this.archived = row.archived;
        this.jobStatusAccess = row.jobStatusAccess;
        this.autoAddJobsites = row.autoAddJobsites;
        this.jobDefaultBillRate = row.jobDefaultBillRate;
        this.jobDefaultCostRate = row.jobDefaultCostRate;
        this.userDefaultBillRate = row.userDefaultBillRate;
    }
    accessorId: number;
    hasAccess: boolean;
    hasNotificationAccess: boolean;
    accessorName: string;
    isSelected: boolean;
    disableAccess: boolean;
    archived: boolean;
    jobStatusAccess: number[];
    autoAddJobsites: boolean;
    jobDefaultBillRate: number | null;
    jobDefaultCostRate: number | null;
    userDefaultBillRate: number | null;
}

export interface IViewingAccessApiResponse {
    internalUserViewingAccess: IJobAccessVm[];
    subUserViewingAccess: IJobAccessVm[];
}

export class ViewingAccessEntity {
    constructor(data: IViewingAccessApiResponse) {
        this.subUserViewingAccess = data.subUserViewingAccess.map(
            (sub) => new ViewingAccessRowEntity(sub),
        );
        this.internalUserViewingAccess = data.internalUserViewingAccess.map(
            (user) => new ViewingAccessRowEntity(user),
        );
    }
    internalUserViewingAccess: ViewingAccessRowEntity[];
    subUserViewingAccess: ViewingAccessRowEntity[];
}

export class ViewingAccessFormValues {
    constructor(data: ViewingAccessEntity) {
        this.subs = data.subUserViewingAccess.map((sub) => new ViewingAccessRowFormValues(sub));
        this.users = data.internalUserViewingAccess.map(
            (user) => new ViewingAccessRowFormValues(user),
        );
    }
    users: ViewingAccessRowFormValues[];
    subs: ViewingAccessRowFormValues[];
}

export function getViewingAccessValidators() {
    return yup
        .object()
        .shape<ViewingAccessFormValues>({
            subs: yup.array().of(yup.mixed()).label("Subs Viewing Access"),
            users: yup.array().of(yup.mixed()).label("Internal Users Viewing Access"),
        })
        .label("Viewing Access");
}
